const VERSION = "1.6.23" //版本号

let env = "108";

let windowHref = window.location.href;
let baseUrl = '';
let baseImgUrl = '';
console.log(windowHref)
if (windowHref.indexOf('10.10.80.52') != -1) {
    //测试环境
    baseUrl = "http://10.10.80.52:8081" //基础api域名,环境
    baseImgUrl = 'http://10.10.80.52:8081';
}else if (windowHref.indexOf('10.10.80.70') != -1) {
  //测试环境
  baseUrl = "http://10.10.80.70:8081" //基础api域名,环境
  baseImgUrl = 'http://10.10.80.70:8081';
} else if (windowHref.indexOf('design.decent9999.com') != -1) {
    //生产环境
    baseUrl = "https://design.decent9999.com/designResetApi" //基础api域名,环境
    baseImgUrl = 'https://design.decent9999.com/designBackApi/sys/common/static/';
} else if (windowHref.indexOf('http://10.10.80.70') != -1) {
           baseUrl = "http://10.10.80.70:8081" //基础api域名,环境
           baseImgUrl = 'http://10.10.80.70:8081';
 }else {
    //本地
    // baseUrl = "http://10.10.81.133:8082" //博远
    baseUrl = "http://10.10.80.52:8081"

    baseImgUrl = 'http://10.10.80.52:8081';
}


module.exports = {
    baseUrl,
    VERSION,
    env,
    baseImgUrl
}



// WEBPACK FOOTER //
// ./src/api/config.js